(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
//function to remove extra number from the progress bar
function hideOtherProgress(num) {
    for (let i = num; i < 7; i++) //remove all progress bar number which is greater than the provided number
    {
        if ($(`[data-number=${i}]`).length > 0) { $(`[data-number=${i}]`).remove(); }
    }
}
function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function addProgressNumber(num) {
    if (num > 10 && $(`[data-number=${num}]`).length === 0) //append new progress number if that is not available in the progress bar
    {
        $(".progress-list").append($("<li>").attr("data-number", num).text(num));
    }
}

//function to make progress bar element active
function setProgressActive(cur, next) {
    //default functionality is when user click on the next button take id from the next button check its corresponding progress value and add that it in the current progress bar
    let currentBlock = $(`[data-id=${cur}]`); //get the current block
    let nextBlock = $(`[data-id=${next}]`); //get the next block
    let progress = '';
    let nextProgress = parseFloat($(nextBlock).attr("data-progress"));

    if (nextBlock.length > 0 && nextProgress > 0) {
        progress = $(nextBlock).attr("data-progress"); //get the progress value of the next block
        if (progress > 8 && $(`[data-number=${progress}]`).length === 0) //if progress value more than 8 append new li element in the list
        {
            $(".progress-list").append($("<li>").attr("data-number", progress).text(progress));
        }
        let num = parseFloat(progress); //change string to number
        for (let i = 1; i < num; i++) //make all progress less than the current active progress filled
        {
            if ($(`[data-number=${i}]`).length > 0) {
                $(`[data-number=${i}]`).addClass("filled");
            } else {
                $(".progress-list").append(`<li class="filled" data-number=${i}>${escapeHtml(i.toString())}</li>`);
            }
        }
        addProgressNumber(progress);
        $(`[data-number=${progress}]`).addClass("active"); //make next block active when click on next button of the current block
    }
    else {
        //if next navigation is not available or next navigation has data progress less than 0
        progress = $(currentBlock).attr("data-progress");
        if (nextProgress === 0 && !$(nextBlock).hasClass("no-input-section")) {
            //if progress value is 0 and next block do not has no-input-section class. no-input class is lead-form class. it means this section will target all program screen which not leading to leads form
            $(`[data-number=${progress}]`).addClass("filled");
            addProgressNumber(parseFloat(progress) + 1);
            let key = $(nextBlock).attr("data-prog-key");

            if (key && key.length > 0) {
                addProgressNumber(parseFloat(progress) + 2);
                //if service component next target is leads generation form then do not filled thge next progress number, made it active
                $(`[data-number=${parseFloat(progress) + 1}]`).addClass("active");
            }
            else {
                $(`[data-number=${parseFloat(progress) + 1}]`).addClass("filled");
            }
        }
        else {
            //this section is for that program which leads to attic-form
            let max = 5;

            for (let i = 1; i < max; i++) //make all progress less than the current active progress filled
            {
                if ($(`[data-number=${i}]`).length > 0) {
                    $(`[data-number=${i}]`).addClass("filled");
                } else {
                    $(".progress-list").append(`<li class="filled" data-number=${i}>${escapeHtml(i.toString())}</li>`);
                }
            }

            if ($(`[data-number=${max}]`).length > 0) {
                $(`[data-number=${max}]`).addClass("active");
            }
            else {
                $(".progress-list").append(`<li class="active" data-number=${max - 1}>${escapeHtml((max - 1).toString())}</li>`);
            }
        }
    }
    $(".progress-container").show();
    $(".main-description").hide();
}

$(".wholesHomeRadio").eq(1).on("change", function () {
    $(".fuel-type-show").val($(".wholesHomeRadio").eq(1).find(":radio:checked").parent().text());
});

$(".hwp-input-control").on("change", function () {
    if ($(this).val() === "Other") {
        $(".other-text-box").show();
        $(".other-text-box").attr("required", "required");
    }
    else {
        $(".other-text-box").hide();
        $(".other-text-box").removeAttr("required");
    }
});

$(document).ready(function () {
    $("button").click(function () {
        if ($(".active #emailTemplate").val() != undefined || $(".active #emailTemplate").val() != null) {
            sessionStorage.setItem("EmailTemplate", $(".active #emailTemplate").val());
        }
    });
    var questionBlock = document.querySelectorAll(".question-block.only-question-block");
    var questionIndex = [];
    $(".question-block:first").addClass("active");
    $(".other-text-box").hide();
    $(".question-container .bottom-desc #eligibilityBlock").hide();

    //loop to get all question id(including services id) and saved in the array
    for (let i = 0; i < questionBlock.length; i++) {
        let uniqueIndex = $(questionBlock[i]).attr("data-id");
        questionIndex.push(uniqueIndex);
    }
    var tooltipValue = sessionStorage.getItem("tooltip");
    if (tooltipValue !== undefined && tooltipValue !== null) {
        $(".tooltiptext").html(tooltipValue);
        $(".dropdown-tooltip").show();
    }
    // auto populate from cookies
    for (i = 0; i < questionIndex.length; i++) {
        let nextTextButton = $(`[data-id = ${questionIndex[i]}] .ongrid-btn`);
        $('.error-msg1, .error-msg2').hide();
    }
    //cookie code
    for (i = 0; i < questionIndex.length; i++) {
        let container = $(`[data-id=${questionIndex[i]}]`);
        if ($(container).has('select').length > 0) {
            let select = $(container).find('select');
            let id = $(select).attr('id');
            if (id === '8B2CCCC9AF694D13BF249EA354A1C42A-select-name') {
                if ($(container).hasClass('active')) {
                    $.get('/api/DSMCookie/GetHouseTypeFromCookie', function (result) {
                        if (result === undefined || result === null || result === "") {
                            $("#8B2CCCC9AF694D13BF249EA354A1C42A-select-name").val("");
                        }
                        else {
                            $("#8B2CCCC9AF694D13BF249EA354A1C42A-select-name").val(sessionStorage.getItem("430EAD662B0749CEA5799EF241A5780C-select-name"));
                            $(`#8B2CCCC9AF694D13BF249EA354A1C42A-select-name option[id=${result}]`).attr("selected", "selected");
                            var element = $("#8B2CCCC9AF694D13BF249EA354A1C42A-select-name").find('option:selected').attr("data-value");
                            //setting the tooltip from cookies
                            //let tooltip = $("#8B2CCCC9AF694D13BF249EA354A1C42A-select-name").find('option:selected').attr("data-tooltip");
                            //if (tooltip && tooltip.length > 0) {
                            //    $(".tooltiptext").text(tooltip);
                            //    $(".dropdown-tooltip").show();
                            //}
                            let nextButton = $("#8B2CCCC9AF694D13BF249EA354A1C42A-select-name").parent().parent().find(".next-btn");
                            $(nextButton).attr("data-next", element);
                        }
                    })
                }
            }
        }
    }

    function hideEnergyContainer() {
        $(".energy-saving-container").removeClass("active");
        $(".overarching-button-container").show();
    }

    function checkEnergyContainer(block, id) {
        let currentBlock = $(`[data-id=${block}]`);
        let energyContainer = $(currentBlock).find(".energy-saving-container");
        let energyID = $(energyContainer).attr("data-id");

        if (energyContainer && energyID && energyID === id) {
            return true;
        }
        else {
            return false;
        }
    }

    //code for getting the next question when we click next button on any dropdown question. This function accept a parameter which is actually a next question id
    function getDropdownNextQuestion(block) {
        let currentBlock = $(`[data-id=${block}]`); //get the current block
        let nextBtn = $(`[data-id=${block}]`).find(".next-btn"); //find the next button in the current block
        let yes = $(nextBtn).attr("data-next"); //get next question ID
        sessionStorage.setItem("IRPcurrentQuestion", block); //save in the session about the current question
        let val = '';
        val = $(`[name=${block}-select-name]`).val();
        let select = $(currentBlock).find('select');
        let id = $(select).attr('id');

        // calling the cookie and passing value for hometype
        if (id === '8B2CCCC9AF694D13BF249EA354A1C42A-select-name') {
            $.get("/api/DSMCookie/SaveHouseTypeFromCookie", { houseType: val });
        }
        if (val === undefined || val === "" || val === null) {
            $(`[data-id=${block}] .error-msg`).show();
            let nextBlock = $(`[data-id=${yes}]`)
            if ($(nextBlock).hasClass("no-input-section")) {
                let key = $(currentBlock).attr("data-prog-key");
                let msg = $(currentBlock).attr("data-msg");
                sessionStorage.setItem("programKey", key);
                sessionStorage.setItem("programMessage", msg);
                $("[for='LeadFormData_UserAcceptance'] span").text(msg);
                setProgressActive(block, yes);
                $(".question-block").removeClass("active");
                sessionStorage.setItem(block, yes);
                $(`[data-id=${yes}]`).addClass("active");
            }

        }
        else {
            let energyContainer = $(currentBlock).find(".energy-saving-container");
            let energyID = $(energyContainer).attr("data-id");

            if (energyID === yes) {
                $(energyContainer).addClass("active");
                $(currentBlock).find(".overarching-button-container").hide();
            }
            else {
                setProgressActive(block, yes);

                $(".question-block").removeClass("active");
                sessionStorage.setItem(block, yes);
                $(`[data-id=${yes}]`).addClass("active");
            }

        }
    }

    //Postal code validations
    function getTextNextQuestion(block) {
        //Postal code value from user input
        let val = $(`[name=${block}-text-name]`).val();
        //Postal code JSON string from the sitecore
        let dataAttr = $(".sarnia-postal-code-list")[0].innerHTML;

        let rawCodes = [];
        try {
            //Parse the JSON string into an array
            rawCodes = JSON.parse(dataAttr);
        } catch (e) {
            console.error("Invalid JSON in List:", e);
            rawCodes = [];
        }

        //Remove spaces, trim, and convert to lowercase
        const validCodes = Array.isArray(rawCodes)
            ? rawCodes.map(code => code.replace(/\s+/g, '').trim().toLowerCase())
            : [];

        //Separate the codes into 3-digit and 6-digit lists
        const valid3DigitCodes = validCodes.filter(code => code.length === 3);
        const valid6DigitCodes = validCodes.filter(code => code.length === 6);

        // Get the ID of the next question block
        let next = $(`[name=${block}-text-name]`).parent().parent().next().attr("data-id");

        //If input is empty/null, show error message and exit
        if (!val) {
            $(`[data-id=${block}] .error-msg`).show();
            $(`[data-id=${block}] .error-msg1`).hide();
            $(`[data-id=${block}] .error-msg2`).hide();
            return;
        }

        $(`[data-id=${block}] .error-msg`).hide();

        //Input value: Remove spaces and convert to lowercase
        let inputVal = val.trim().replace(/\s+/g, '').toLowerCase();
        let first3 = inputVal.substring(0, 3);
        let first6 = inputVal.substring(0, 6);

        //Check if the input matches either a valid 6-digit or 3-digit postal code
        const isValid =
            (inputVal.length >= 6 && valid6DigitCodes.includes(first6)) ||
            valid3DigitCodes.includes(first3);

        //Check if postal code is having 6 or more characters
        if (inputVal.length >= 6) {
            if (isValid) {
                $(`[data-id=${block}] .error-msg1`).hide();
                $(`[data-id=${block}] .error-msg2`).hide();
                $(".question-block").removeClass("active");
                setProgressActive(block, next);
                $(`[data-id=${next}]`).addClass("active");
            } else {
                $(`[data-id=${block}] .error-msg2`).show();
                $(`[data-id=${block}] .error-msg1`).hide();
            }
        } else {
            $(`[data-id=${block}] .error-msg2`).hide();
            $(`[data-id=${block}] .error-msg1`).show();
        }
    }

    //function to get next question once user click next button of yes-no question
    function getNextQuestion(yes, no, pwo, pwoeng, block) {
        let currentBlock = $(`[data-id=${block}]`);
        let energyContainer = $(currentBlock).find(".energy-saving-container");
        let val = $(`[name=${block}-radio-name]:checked`).val();

        if (val !== undefined) {
            if (val === "yes" || val === "Yes" || val === "YES") {
                if (checkEnergyContainer(block, yes)) {
                    $(energyContainer).addClass("active");
                    $(currentBlock).find(".overarching-button-container").hide();
                }
                else {
                    sessionStorage.setItem("IRPcurrentQuestion", block);
                    $(".question-block").removeClass("active");
                    $(`[data-id=${yes}]`).addClass("active");
                    setProgressActive(block, yes);
                }
            }
            else if (val === "pwo" || val === "Pwo" || val === "PWO") {
                if (checkEnergyContainer(block, pwo)) {
                    $(energyContainer).addClass("active");
                    $(currentBlock).find(".overarching-button-container").hide();
                }
                else {
                    sessionStorage.setItem("IRPcurrentQuestion", block);
                    $(".question-block").removeClass("active");
                    $(`[data-id=${pwo}]`).addClass("active");
                    setProgressActive(block, pwo);
                }
            }
            else if (val === "pwoeng" || val === "Pwoeng" || val === "PWOENG") {
                if (checkEnergyContainer(block, pwoeng)) {
                    $(energyContainer).addClass("active");
                    $(currentBlock).find(".overarching-button-container").hide();
                }
                else {
                    sessionStorage.setItem("IRPcurrentQuestion", block);
                    $(".question-block").removeClass("active");
                    $(`[data-id=${pwoeng}]`).addClass("active");
                    setProgressActive(block, pwoeng);
                }
            }
            else {
                if (checkEnergyContainer(block, no)) {
                    $(currentBlock).find(".energy-saving-container").addClass("active");
                    $(currentBlock).find(".overarching-button-container").hide();
                }
                else {
                    sessionStorage.setItem("IRPcurrentQuestion", block);
                    $(".question-block").removeClass("active");
                    $(`[data-id=${no}]`).addClass("active");
                    setProgressActive(block, no);
                }
            }

        }
        else {
            $(`[data-id=${block}] .error-msg`).show();
        }
    }

    function showProgress() {

        if ($('[data-number="1"]').hasClass("active")) {
            $(".main-description").show();
        }
    }

    function removeProgressFill(block) {
        $(".progress-list li").removeClass("active");
        let currentBlock = $(`[data-id=${block}]`); //get the current block
        let progress = $(currentBlock).attr("data-progress");
        removeNextFilled(progress);
        $(`[data-number=${progress}]`).addClass("active");
        showProgress();
    }

    function removeNextFilled(num) {
        let progress = parseFloat(num);
        for (let i = progress; i < 8; i++) {
            $(`[data-number=${i}]`).removeClass("filled");
        }
    }

    //function to get previous questions
    function getPrevQuestion(num) {
        $(".question-block").removeClass("active");
        $(`[data-id=${num}]`).addClass("active");
        sessionStorage.setItem("IRPcurrentQuestion", num);
        removeProgressFill(num);
        $('html, body').animate({
            scrollTop: $(".own-operate").offset().top
        })
    }

    //loop to get all previous and next button and add click event on it
    for (let i = 0; i < questionIndex.length; i++) {
        if (questionIndex[i] !== undefined) {
            //setting the session values to input
            let nextButtonTag = $(`[data-id=${questionIndex[i]}] .next-btn`);
            let nextTextButton = $(`[data-id=${questionIndex[i]}] .ongrid-btn`);
            let nextDisabled = $(nextButtonTag).attr("data-disabled");
            makeDisabled(nextButtonTag, nextDisabled);
            makeDisabled(nextTextButton, nextDisabled);
            let yes = $(nextButtonTag).attr("data-yes");
            let no = $(nextButtonTag).attr("data-no");
            let pwo = $(nextButtonTag).attr("data-pwo");
            let pwoeng = $(nextButtonTag).attr("data-pwoeng");
            let nextLink = $(nextButtonTag).attr("data-next");
            let prevButtonTag = $(`[data-id=${questionIndex[i]}] .prev-btn`);
            let prevDisabled = $(prevButtonTag).attr("data-disabled");
            makeDisabled(prevButtonTag, prevDisabled);
            let prevLink = $(prevButtonTag).attr("data-next");
            let gaLink = $(nextButtonTag).attr("data-question");
            let gaTextLink = $(nextTextButton).attr("data-question");

            if (nextTextButton.length !== 0) {
                $(nextTextButton).on("click", function () {
                    getTextNextQuestion(questionIndex[i])
                    $('html, body').animate({
                        scrollTop: $(".own-operate").offset().top
                    })
                    window.dataLayer.push({
                        'event': 'Screen Tracking',
                        'Question_completed': gaTextLink,
                        'Page': 'AtticApplication'
                    });
                    hideProgressBar();
                })
            }
            else {
                if (nextLink === undefined) {
                    $(nextButtonTag).on("click", function () {
                        getNextQuestion(yes, no, pwo, pwoeng, questionIndex[i])
                        $('html, body').animate({
                            scrollTop: $(".own-operate").offset().top
                        })
                        window.dataLayer.push({
                            'event': 'Screen Tracking',
                            'Question_completed': gaLink,
                            'Page': 'AtticApplication'
                        });
                        hideProgressBar();
                    })
                }
                else {
                    $(nextButtonTag).on("click", function () {
                        getDropdownNextQuestion(questionIndex[i])
                        $('html, body').animate({
                            scrollTop: $(".own-operate").offset().top
                        })
                        window.dataLayer.push({
                            'event': 'Screen Tracking',
                            'Question_completed': gaLink,
                            'Page': 'AtticApplication'
                        });
                        hideProgressBar();
                    })
                }
            }

            $(prevButtonTag).on("click", function () {
                getPrevQuestion(prevLink);
                $(".progress-container").show();
            })
        }
    }

    //code to add change method on each input and select field
    for (i = 0; i < questionIndex.length; i++) {
        let container = $(`[data-id = ${questionIndex[i]}]`);
        let error = $(container).find(".error-msg");
        if ($(container).has('input').length > 0 || $(container).has('select').length > 0) {
            if ($(container).has('input[type=radio]').length > 0) {
                let input = $(container).find('input');
                $(input).on("change", function () {
                    let name = $(input).attr('name');
                    let value = $(`input[name=${name}]:checked`).val();
                    if (value !== undefined) {
                        $(error).hide();
                        hideEnergyContainer();
                        sessionStorage.setItem(name, value);
                    }
                });
            }
            if ($(container).has('input[type=text]').length > 0 && !$(container).hasClass("no-input-section")) {
                let input = $(container).find('input');
                $(input).on("change", function () {
                    let name = $(input).attr('name');
                    let value = $(`input[name=${name}]`).val();
                    if (value !== undefined || value !== null || value !== "") {
                        sessionStorage.setItem(name, value);
                    }
                });

            }
            if ($(container).has('select').length > 0) {
                let select = $(container).find('select');
                $(select).on("change", function () {
                    let name = $(select).attr('name');
                    let nextButton = $(this).parent().parent().find(".next-btn");
                    let val = $(this).val();
                    let element = $(this).find('option:selected');
                    let navigation = $('option:selected', this).attr('data-value');
                    let myTag = element.attr("data-tooltip");
                    if (myTag && myTag.length > 0) {
                        $(".dropdown-tooltip").show();
                        $(".tooltiptext").html(myTag);
                        sessionStorage.setItem("tooltip", myTag);
                        hideEnergyContainer();
                    }
                    else {
                        $(".dropdown-tooltip").hide();
                        sessionStorage.removeItem("tooltip");
                        hideEnergyContainer();
                    }

                    if (val !== undefined) {
                        $(nextButton).attr("data-next", navigation);
                        $('.next-btn').show();
                        $('.energy-saving-container').hide();
                        $(error).hide()
                        hideEnergyContainer();
                        sessionStorage.setItem(name, val);
                    }
                });
            }
        }
    }

    for (i = 0; i < questionIndex.length; i++) {
        let container = $(`[data-id = ${questionIndex[i]}]`);
        if ($(container).has('input').length > 0) {
            let select = $(container).find('select');
            $(select).on("change", function () {
                let val = $(this).val;
                if (val !== questionIndex[i]) {
                    $(`[data-id=${questionIndex[i]}] .next-btn`).show()
                }
            })
        }
    }

    //code to make all the input and select field values null and clear all the session variable too
    function setDefaultValue() {
        for (i = 0; i < questionIndex.length; i++) {
            let container = $(`[data-id = ${questionIndex[i]}]`);
            if ($(container).has('input').length > 0 || $(container).has('select').length > 0) {
                if ($(container).has('input').length > 0) {
                    let input = $(container).find('input');
                    $(input).val([""]);
                }
                if ($(container).has('select').length > 0) {
                    let select = $(container).find('select');
                    $(select).val("");
                }
            }
        }
    }

    function makeDisabled(btn, value) {
        if (value === "1") {
            $(btn).prop("disabled", true);
        }

    }

    function hideProgressBar() {
        if ($(".progressBarHide").length) {
            $(".progressBarHide").each(function () {
                if ($(this).parent().parent().hasClass("active")) {
                    $(".progress-container").hide();
                }
            });
        }
    }

    if ($(".attic-heat-home").eq(4).find(":radio:checked").val() == "No") {
        $(".egd-acc-no").show();
        $('.egd-acc-no .form-control').attr('required', true);
    }
    else {
        $(".egd-acc-no").hide();
        $('.egd-acc-no .form-control').removeAttr('required');
    }

    $(".attic-heat-home").eq(4).on("change", function () {
        if ($(".attic-heat-home").eq(4).find(":radio:checked").val() == "No") {
            $(".egd-acc-no").show();
            $('.egd-acc-no .form-control').attr('required', true);
        }
        else {
            $(".egd-acc-no").hide();
            $('.egd-acc-no .form-control').removeAttr('required');
        }
    });
})
},{}],2:[function(require,module,exports){
$(document).ready(function () {
    let random = Math.floor(Math.random() * 100000 + 1);
    $("#LeadForm").attr("autocomplete", random);
    $("#LeadFormData_FirstName").attr("autocomplete", random);
    $("#LeadFormData_LastName").attr("autocomplete", random);
    $("#LeadFormData_EmailAddress").attr("autocomplete", random);
    $("#LeadFormData_Address").attr("autocomplete", random);
    $("#LeadFormData_Address2").attr("autocomplete", random);

    const city = document.getElementById('LeadFormData_City');
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(city), 'value');
    Object.defineProperty(city, 'value', {
        set: function (t) {
            $(city).removeClass("parsley-error");
            $(city).removeClass("parsley-success");
            $(city).parent().find("ul").removeClass("filled");

            return descriptor.set.apply(this, arguments);
        },
        get: function () {
            return descriptor.get.apply(this);
        }
    })
    const province = document.getElementById('LeadFormData_Province');
    const provinceDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(province), 'value');
    Object.defineProperty(province, 'value', {
        set: function (t) {
            $(province).removeClass("parsley-error");
            $(province).removeClass("parsley-success");
            $(province).parent().find("ul").removeClass("filled");
            return provinceDescriptor.set.apply(this, arguments);
        },
        get: function () {
            return provinceDescriptor.get.apply(this);
        }
    })
    const postalcode = document.getElementById('LeadFormData_Postalcode');
    const postalDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(postalcode), 'value');
    Object.defineProperty(postalcode, 'value', {
        set: function (t) {
            $(postalcode).removeClass("parsley-error");
            $(postalcode).removeClass("parsley-success");

            $(postalcode).parent().find("ul").removeClass("filled");
            return postalDescriptor.set.apply(this, arguments);
        },
        get: function () {
            return postalDescriptor.get.apply(this);
        }
    })

    function clearForm() {
        document.getElementById("LeadForm").reset();
    }

    function checkInputField(element) {
        //get the element
        let input = $(element).parsley();
        return !(input.validate() === true)
    }

    function checkValidation() {
        //every input field has some values
        //check for both checkbox weather they are checked or not
        if ($("#LeadFormData_ProgramAcceptance").is(":checked")) {
            //both checkbox are checked

            return true;
        }
        else {
            //either of the checkbox is not checked
            return false;
        }
    }

    $("#LeadForm").on('submit', function (e) {
        // after form is validated, validate reCaptcha if it is not disabled
        e.preventDefault();

        if (!checkValidation()) {

        }
        else {
            var reCaptchaDisabled = $("#reCaptchaDiv").val() == null || $("#reCaptchaDiv").val() == undefined;
            if (!reCaptchaDisabled) {
                grecaptcha.ready(function () {
                    var siteKey = $('#reCaptchaDiv').val();
                    grecaptcha.execute(siteKey, { action: 'LeadForm' }).then(function (token) {
                        SubmitLeadForm(token);
                    });
                });
            }
            else {
                SubmitLeadForm('');
            }
        }
    });

    function SubmitLeadForm(reCaptchaValidationResponse) {
        $("#SubmitBtn").prop("disabled", true);
        $("#div-global-loader-box").show();
        let url = $("#LeadForm").attr('action');
        let key = sessionStorage.getItem("programKey");
        let msg = sessionStorage.getItem("programMessage");
        let isUsrAcceptConsent = $("#LeadFormData_UserAcceptance").is(":checked");
        let lowIncomeConsent = $("#LeadFormData_ProgramAcceptanceOptional").is(":checked");
        let antiforgerytoken = $('input[name="__RequestVerificationToken"]').val();
        let emailTemplate = sessionStorage.getItem("EmailTemplate");

        $.ajax({
            type: "POST",
            url: url,
            data: $('#LeadForm').serialize() + "&LeadFormData.EmailTemplate=" + emailTemplate + "&LeadFormData.FuelType=" + $(".col-sarnia").eq(0).find(":radio:checked").attr("data-select") + "&LeadFormData.LeadType=" + $("#leadType").val() + "&LeadFormData.programkey=" + key + "&LeadFormData.programMessage=" + msg + "&LeadFormData.isUsrAcceptConsent=" + isUsrAcceptConsent + "&LeadFormData.isUsrAcceptIncomeConsent=" + lowIncomeConsent + "&__RequestVerificationToken=" + antiforgerytoken + "&LeadFormData.ReCaptchaValidationResponse=" + reCaptchaValidationResponse,
            cache: false,
            processData: false,
            dataType: 'json',
            error: function (xhr, status, error) {
                let msg = $("#antyforgery-Msg").text();
                $("#SubmitBtn").prop("disabled", false);
                $(".leads-form-container").removeClass("active");
                $(".welcome-message-container").text(msg);
                $(".welcome-message-container").addClass("active");
                $(".question-container").hide();
                $('html, body').animate({
                    scrollTop: $(".main-container").offset().top
                })
                $("#div-global-loader-box").hide();
            },
            success: function (response) {
                $("#div-global-loader-box").hide();
                if (response) {
                    if (response.Status === 400) {
                        clearForm();
                        $("#SubmitBtn").prop("disabled", false);
                        $(".leads-form-container").removeClass("active");
                        $(".welcome-message-container").html(response.ViewString);
                        $(".welcome-message-container").addClass("active");
                        $(".question-container").hide();
                        clearForm();
                        sessionStorage.clear();
                        $('html, body').animate({
                            scrollTop: $(".main-container").offset().top
                        })
                    }
                    else {
                        $("#SubmitBtn").prop("disabled", false);
                        $(".leads-form-container").removeClass("active");
                        $(".rea-block-container").html(response.ViewString);
                        $(".rea-list-container").addClass("active");
                        $(".question-container h2").hide()
                        $(".question-container .bottom-desc #eligibilityBlock").show();
                        $(".progress-list li").addClass("filled");
                        $(`[data-number="5"]`).addClass("filled");

                        clearForm();
                        sessionStorage.clear();
                        $('html, body').animate({
                            scrollTop: $(".main-container").offset().top
                        })
                        window.dataLayer.push({
                            'event': 'Screen Tracking',
                            'Question_completed': 'GHForm_Submitted',
                            'Page': 'GHLeadForm'
                        });
                    }
                }
            }
        });
    }

    function clearSomeInput() {
        //clear name
        $("#LeadFormData_Address").val("");
        $("#LeadFormData_Address2").val("");
        $("#LeadFormData_City").val("");
        $("#LeadFormData_Province").val("");
        $("#LeadFormData_Postalcode").val("");
        $("#LeadFormData_ProgramSource").val("");
    }

    $(".post-alert-no, .zip-alert-close").on("click", function () {
        $("#myModalZipAlert").modal('hide');
        clearSomeInput();
    });

    $('#myModalZipAlert').on('hidden.bs.modal', function () {
        clearSomeInput();
    });

    $(".post-alert-yes").on("click", function () {
        let secondScreen = $("[name*='text-name']").parent().parent();
        let secondScreenID = $(secondScreen).attr("data-id");
        $("#myModalZipAlert").modal('hide');
        $(".question-block").removeClass("active");
        $(`[data-id=${secondScreenID}]`).addClass("active");
        $(".progress-list li").removeClass("active");
        $(".progress-list li").removeClass("filled");
        $("[data-number='1']").addClass("active");
        hideOtherProgress(7);
        clearSomeInput();
        $('html, body').animate({
            scrollTop: $(".main-container").offset().top
        })
    })
})
},{}],3:[function(require,module,exports){
var AtticFormScript = require("./Components/Feature/DSM/IRPsarniaScript.js");
var ValidateAtticForm = require("./Components/Feature/DSM/ValidateIRPForm.js");

},{"./Components/Feature/DSM/IRPsarniaScript.js":1,"./Components/Feature/DSM/ValidateIRPForm.js":2}]},{},[3]);
